import * as types from './mutations-types'

import { flux as Flux } from '@octadesk/chat-domain'

import { orderby } from '@/helpers'

const sortAndSlicePages = pages =>
  orderby.desc(pages, item => item.enterDate).slice(0, 20)

export default {
  [types.SET_RESTORING](state, value) {
    state.restoringSession = value
  },
  [types.SET_PAGES](state, pages) {
    state.session.pages = sortAndSlicePages(pages)
  },
  [types.ADD_PAGE](state, page) {
    state.session.pages = sortAndSlicePages([...state.session.pages, page])
  },
  [types.SET_PAGE](state, url) {
    state.session.page = {
      url,
      enterDate: new Date(),
      leaveDate: undefined,
      scrollPercent: 0
    }
  },
  [types.SET_EXTERNAL_LOGIN](state) {
    state.session.externalLogin = true
  },
  [types.SET_FLUX](state, flux) {
    state.flux = flux ? new Flux(flux) : null
    state.session.fluxId = (state.flux && state.flux.id) || undefined
  },
  [types.SET_SCROLL_PERCENT](state, percent) {
    state.session.page.scrollPercent = percent
  },
  [types.SET_EXISTENT_CONTACT](state, value) {
    state.session.existentContact = value
  },
  [types.SET_SURVEY_FINISHED](state, isSurveyFinished) {
    state.surveyFinished = isSurveyFinished
  }
}
